import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { Foodcourt } from 'src/app/model/foodcourt.model';
import { AddfoodvendorService } from 'src/app/services/addfoodvendor.service';
import { FoodcourtService } from 'src/app/services/foodcourt.service';
import { DateService } from 'src/app/services/date.service';
import { CommonService } from 'src/app/services/common.service';
import { RemovemodalvendorComponent } from 'src/app/modal/remove-modal-vendor/remove-modal-vendor.component';
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';
@Component({
  standalone: false,
  selector: 'app-details-vendor',
  templateUrl: './details-vendor.component.html',
  styleUrls: ['./details-vendor.component.scss']
})
export class DetailsVendorComponent implements OnInit {

  public couponsection = new Foodcourt();
  private subscriptions = new Subscription();

  vendorId: any;
  vendorDetails: any;
  groupId: string = null;
  fromDetailsPage: any;
  checkedOnlyUsersList: any;
  vendorlogo = 'vendorlogo';
  tempDate: any;
  singleVendorId = [];
  fromListPage = 'no';
  singleVendorDataDelete = [];
  ismarkAsClosed: boolean = false;
  Form: FormGroup;
  foodCourtId: any;
  foodvendorRemove: any;
  foodvendorEdit: any;
  foodvendorCreate: any;
  foodvendorView: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private dateAdapter: NgbDateAdapter<string>,
    private dateSrv: DateService,
    private addfoodvendorService: AddfoodvendorService,
    private foodcourtService: FoodcourtService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private rolebasedactionService: RolebasedactionService,
  ) {
    localStorage.setItem('expandNavFoodCourt', 'true');
    const routeLink = this.sideNavService.routingChunks({
      name: 'Food Court Management',
      subNav: '1',
      subNavLink: '',
    });
    this.appStateSrv.setSideNavState(routeLink);

    this.Form = this.fb.group({
      ismarkAsClosed: []
    });
  }

  ngOnInit(): void {
    this.foodvendorRemove = this.rolebasedactionService.checkUserRolePermissionExits('Food Court:Remove');
    this.foodvendorEdit = this.rolebasedactionService.checkUserRolePermissionExits('Food Court:Edit');
    this.foodvendorCreate = this.rolebasedactionService.checkUserRolePermissionExits('Food Court:Create');
    this.foodvendorView = this.rolebasedactionService.checkUserRolePermissionExits('Food Court:View');
    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');
    localStorage.removeItem('expandNavCreateview');

    this.route.params.subscribe((params) => {
      this.vendorId = params['id'];
    });

    this.foodCourtId = localStorage.getItem('food_court_id');

    this.getVendorDetails();
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavFoodCourt');
    this.subscriptions.unsubscribe();
  }

  openModalRemoveVendor(surveyId): void {

    this.singleVendorDataDelete = [];

    this.singleVendorDataDelete.push({
      "FoodCourtVendorId": this.vendorId, //this.onlyVendorIds
      "deletedBy": localStorage.getItem('claAdminId')
    });

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(RemovemodalvendorComponent, modalOptions);
    modalRef.componentInstance.foodCourtVendorId = this.singleVendorDataDelete[0];
    modalRef.componentInstance.fromDetailsPage = 'yes';
  }

  markTheVendorOpenClose(event) {
    console.log(event.target.checked);

    let opt = {
      IsMarkClosed: event.target.checked,
      FoodCourtVendorId: this.vendorId,
      ModifiedBy: localStorage.getItem('claAdminId')
    }

    this.foodcourtService.updateMarkAsClosedOpened(opt).subscribe((res) => {
      this.ismarkAsClosed = event.target.checked;
      this.getVendorDetails();
    });
  }

  getVendorDetails() {
    this.foodcourtService.getVendorDetails(this.vendorId).subscribe((res) => {
      if (res?.isValid === true) {
        this.vendorDetails = res;
        this.ismarkAsClosed = this.vendorDetails?.data.isMarkClosed;
        localStorage.setItem('vendor_name', this.vendorDetails?.data.foodCourtVendorName);
        this.checkedOnlyUsersList = [];
        this.checkedOnlyUsersList.push(this.vendorDetails.data);
        console.log(this.checkedOnlyUsersList);
      }
    });
  }

  formatDateAll(date, type) {
    if (date == null) return;
    if (type == 'date') {
      this.tempDate = date.split('T')[0].split('-');
      return this.dateSrv.convertDateToLocaleString(this.tempDate[2], this.tempDate[1] - 1, this.tempDate[0]);
    }
    else {
      this.tempDate = date.split('T')[1].split(':')
      let type = this.tempDate[0] <= 12 ? 'AM' : 'PM'
      return (this.tempDate[0] > 12) ? this.tempDate[0] - 12 + ':' + this.tempDate[1] + ' ' + type : this.tempDate[0] + ':' + this.tempDate[1] + ' ' + type

    }
  }

  goToEditPage(id) {
    this.router.navigate(['/update-vendor-details/' + id]);
  }

  listFoodMenuSection(id) {
    this.router.navigate(['/list-food-menu/' + id]);
  }

  addFoodMenuSection(id) {
    this.router.navigate(['/add-food-menu/' + id]);
  }

  gotoReviewPage(id) {
    this.router.navigate(['/vendor-review-list/' + id]);
  }

}
